import styled from 'styled-components'

export const StarContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
`